/**
 * @generated SignedSource<<e54fbe281fd619da15107520e67fb2da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsWordpressArticlesWrapper_itemSearch$data = {
  readonly editorial: {
    readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsModule_editorial" | "SbSharedWordpressArticlesWrapper_editorial">;
  } | null;
  readonly interiorPhotos: {
    readonly photos: ReadonlyArray<{
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsModule_itemSearch">;
  readonly " $fragmentType": "SbRespInteriorsWordpressArticlesWrapper_itemSearch";
};
export type SbRespInteriorsWordpressArticlesWrapper_itemSearch$key = {
  readonly " $data"?: SbRespInteriorsWordpressArticlesWrapper_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsWordpressArticlesWrapper_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsWordpressArticlesWrapper_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespInteriorsModule_itemSearch"
    },
    {
      "alias": "editorial",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 8
        }
      ],
      "concreteType": "WordpressArticlesType",
      "kind": "LinkedField",
      "name": "editorialArticles",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespInteriorsModule_editorial"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedWordpressArticlesWrapper_editorial"
        }
      ],
      "storageKey": "editorialArticles(first:8)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseInteriorPhotosModule",
      "kind": "LinkedField",
      "name": "interiorPhotos",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "701268994eab0d0ec3a8357e02937c78";

export default node;
